<template>
  <div>
    <!-- Start Breadcrump Area  -->
    <div
      class="rn-page-title-area ptb--60 bg_image bg_image--27"
      data-black-overlay="7"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <div class="text-center blog-single-page-title pt--50">
              <h1 class="heading-title theme-gradient">
                Création de votre compte
              </h1>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Breadcrump Area  -->
    <!-- Start Blog Area  -->
    <div class="rn-blog-area ptb--60 bg_color--5">
      <v-container>
        <v-row>
          <v-col cols="12">
            <div>
              <v-stepper alt-labels v-model="e1">
                <v-stepper-header>
                  <v-stepper-step step="1">
                    Vos informations
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="2">
                    Vos amis
                  </v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <h4>
                      Informations personnelles
                    </h4>

                    <FormAccount v-on:updateuser="nextStep(2)"></FormAccount>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <FormContact v-on:inserted="end()"></FormContact>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- End Blog Area  -->
  </div>
</template>

<script>
import FormAccount from "./widget/FormAccount";
import FormContact from "@/views2/user/widget/FormContact";

export default {
  components: { FormAccount, FormContact },
  data() {
    return {
      e1: 1,
      steps: 4
    };
  },
  watch: {
    steps(val) {
      this.$gtm.trackEvent({
        category: "User",
        action: "OnBoarding",
        label: "step",
        value: val
      });
      if (this.e1 > val) {
        this.e1 = val;
      }
    }
  },
  methods: {
    nextStep(n) {
      if (n === this.steps + 1) {
        this.e1 = 1;
      } else {
        this.e1 = n;
      }
    },
    end() {
      this.$store.dispatch("showMenu", true);
      this.$Amplify.Cache.removeItem("redirectInfo");
      document.location.href =
        "https://" +
        this.$Amplify.Auth._config.oauth.domain +
        "/oauth2/authorize?" +
        "response_type=code" +
        "&client_id=" +
        this.$redirectInfo.client_id +
        "&redirect_uri=" +
        this.$redirectInfo.redirect_uri +
        "&state=" +
        this.$redirectInfo.state +
        "&scope=" +
        this.$redirectInfo.scope;
    }
  }
};
</script>
